import React from 'react';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';

// InfoBlocks
import {
  InfoSection,
  FeatureList,
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';


const SoundProof = () => {
  
  const features = [
    {
      title: '우수한 소음 저감 성능',
      bullets: [
      {
        label: (
          <>교통 소음을 효과적으로 감소시켜 주거 및 공공시설의 조용한 생활환경 확보</>
        ),
      },
      {
        label: (
          <>소음 특성에 따른 최적의 재료·두께·구조 설계 적용</>
        ),
      },
      {
        label: (
          <>다양한 주파수 대역의 소음을 안정적으로 차단함</>
        ),
      },
      ]
    },
    {
      title: '주거환경과 건강 보호',
      bullets: [
      {
        label: (
          <>장기적인 소음 노출로 인한 스트레스·수면 방해 등 건강 영향 최소화</>
        ),
      },
      {
        label: (
          <>학교·병원·도서관 등 민감 시설에서 학습·치료·휴식 환경 보장</>
        ),
      },
      {
        label: (
          <>생활 소음에 민감한 지역 주민의 삶의 질을 향상</>
        ),
      },
      ]
    },
    {
      title: '프라이버시 및 안전성 강화',
      bullets: [
      {
        label: (
          <>생활공간의 시야 노출 방지로 프라이버시 보호</>
        ),
      },
      {
        label: (
          <>도로 주변의 잦은 시각적 간섭을 줄여 안정감 제공</>
        ),
      },
      {
        label: (
          <>교통 흐름을 방해하지 않고 운전자 주의 분산을 최소화하는 디자인 적용</>
        ),
      },
      ]
    },
    {
      title: '주변 미관과 도시 경관 개선',
      bullets: [
      {
        label: (
          <>투명·반투명·흡음형·디자인형 등 다양한 패널 타입 제공</>
        ),
      },
      {
        label: (
          <>지역 특성과 조화되는 색상·패턴 적용으로 경관 품질 향상</>
        ),
      },
      {
        label: (
          <>도시·고속도로 환경에 자연스럽게 어우러지는 고급스러운 외관</>
        ),
      },
      ]
    },
  ];

  

  return (
    <>
      <HeroSection
        title={`방음벽 및 방음터널시설`}
        subtitle={`교통 소음을 효과적으로 차단하여 \n쾌적하고 안전한 생활 환경을 제공합니다`}
        backgroundImage="/images/products/facilities/sound-proof3.jpg"
        breadcrumbs={[
          { label: '홈', path: '/' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '방음벽 및 방음터널시설' },
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`소음 차단 및 종합 환경 개선 솔루션`}
        title={`방음벽 및 방음터널시설`}
        description={
          <>
            주택, 학교, 병원, 도서관, 휴양시설 등 조용한 환경이 요구되는 생활권 주변에서 발생하는 교통 소음을 효과적으로 차단하여, {' '}
            주민에게 쾌적하고 안전한 생활 환경을 제공합니다.
            <br />
            <br />
            단순한 소음 차단 기능을 넘어 주거환경 보호, 건강 증진, 프라이버시 확보, 주변 미관 개선, 교통 안전성 향상까지 고려한 {' '}
            종합 환경 개선 솔루션으로 설계되었으며, 다양한 도로·도심 환경에서 축적된 기술력과 풍부한 현장 경험을 바탕으로 기능성과 디자인을 모두 갖춘 시설입니다.
          </>
        }
        images={[
          '/images/products/facilities/sound-proof2.webp',
          '/images/products/facilities/sound-proof3.jpg',
          '/images/products/facilities/sound-proof4.webp',
          '/images/products/facilities/sound-proof5.webp',

        ]}
      />

      <SectionDivider />

      <InfoSection title="제품 특징">
        <FeatureList features={features} />
      </InfoSection>

      <ProductDetailNav
        category="facilities"
        currentPath="/products/facilities/sound-proof"
        listPath="/products/facilities"
      />


      <CTASection />
    </>
  );
};

export default SoundProof;
